module.exports = __webpack_public_path__ + "img/complaints.c6bfeebd.svg";